import { useState }         from 'react'
import agent                from '../api/agent'
import handleError          from '../utils/handleError'

const usePackage = () => {
  const [isLoading, setIsLoading] = useState(false)

  const getPackage = async ({ 
    packageId
  }) => {
    try {
      setIsLoading(true)

      const response = await agent.pkg.getPackage({ packageId })
      return response.data 
    } catch (e) {
      handleError(e)
      throw e
    } finally {
      setIsLoading(false )
    }
  }

  const updatePackage = async (
    updatedPkg
  ) => {
    try { 
      setIsLoading(true)
      const response = await agent.pkg.updatePackage(updatedPkg)

      return response.data
    } catch (e) {
      handleError(e)
      throw e
    } finally {
      setIsLoading(false)
    }
  }
  
  const updatePackageCustomsType = async ({
    outgoingCustomsType, 
    packageId 
  }) => {
    try {
      setIsLoading(true)

      const response = await agent.pkg.updateCustomsType({ outgoingCustomsType }, packageId)
      return response.data
    } catch (e) {
      handleError(e)
      throw e
    } finally {
      setIsLoading(false)
    }
  }

  const getItems = async ({
    packageId,
    disposition,
    type
  }) => {
    try {
      setIsLoading(true)

      const response = await agent.items.getItems({ packageId, disposition, type })
      return response.data
    } catch (e) {
      handleError(e)
      throw e
    } finally {
      setIsLoading(false)
    }
  }

  const addItem = async ({
    packageId,
    item,
    customsType
  }) => {
    try {
      setIsLoading(true)

      const response = await agent.items.addItem({ packageId, item, customsType })
      return response.data
    } catch (e) {
      handleError(e)
      throw e
    } finally {
      setIsLoading(false)
    }
  }

  const updateItems = async ({ 
    packageId, 
    items, 
    customsType
  }) => {
    try {
      setIsLoading(true)

      const response = await agent.items.updateItem({ packageId, items, customsType })
      return response.data
    } catch (e) {
      handleError(e)
      throw e
    } finally {
      setIsLoading(false)
    }
  }

  const deleteItem = async ({
    packageId,
    itemId 
  }) => {
    try {
      setIsLoading(true)
      const response = await agent.items.deleteItem({ packageId, itemId })
      return response.data
    } catch (e) {
      handleError(e)
      throw e
    } finally {
      setIsLoading(false)
    }
  }

  return {
   isLoading,
   getPackage,
   updatePackage,
   updatePackageCustomsType,
   getItems,
   updateItems,
   addItem,
   deleteItem,
  }
}

export default usePackage